import "./Resume.css";
import image from "../asset/undraw_Resume_re_hkth.png";
import pdf from "../hadyhesham-cv.pdf";
function Resume() {
  const onButtonClick = () => {
    fetch(pdf).then((response) => {
      response.blob().then((blob) => {
        const fileURL = window.URL.createObjectURL(blob);
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = pdf;
        alink.click();
      });
    });
  };
  return (
    <main className="container resumePage">
      <div className="row">
        <div className="col-md">
          <img src={image} alt="resume" />
        </div>
        <div className="col-md center resumeDownload">
          <h3>Click on below button to download my resume as PDF file</h3>
          <button onClick={onButtonClick}>Download PDF</button>
        </div>
      </div>
    </main>
  );
}

export default Resume;
